module.exports = __webpack_public_path__ + "img/hr-red-desert-bush-11.2aa87403.png";